<template>
  <div class="node-round">
    <div class="left-section">
      <div class="title">{{$t("superNode.round")}}</div>
      <div class="round">{{this.round}}</div>
      <div class="election">
        <div>{{this.election}}</div>
      </div>
    </div>
    <dna-spin v-if="isLoading"></dna-spin>
    <!-- <div class="right-section">
      <div class="title">{{$t("superNode.totalPeriods")}}</div>
      <div class="period">{{this.period}}</div>
    </div>-->
  </div>
</template>

<script>
import req from "@/req/req.js";
export default {
  data() {
    return {
      round: "",
      election: "",
      isLoading: true
      // period: "22"
    };
  },
  async mounted() {
    let that = this;
    try {
      that.isLoading = true;
      await that.load();
      that.isLoading = false;
    } catch (err) {
      console.log(err);
      that.isLoading = false;
      that.$Message.error({
        background: true,
        duration: 5,
        content: that.$t("global.networkError")
      });
    }
  },
  methods: {
    async load() {
      let that = this;
      let status = await req.fetchBlockStatus();
      if (status) {
        //TODO:和接口对应
        that.round = status.cur_round || "01";
        that.election = status.stage.toUpperCase() || "A";
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import url("./SuperNodeRound.less");
</style>